module.exports = __webpack_public_path__ + "chair.jpg?2e10330c5bc8ff7fa8592d1e4227d8ca";